<div class="homepage">
  <img src="/assets/images/800x800_logo.png" class="agro-logo">
  <div style="position: absolute; top: 20px; right:50px; z-index: 9999">
    <ul>
      <li class="link2 active">
        <a class="link1" href="/">Početna</a>
      </li>
      <li class="link2">
        <a class="link1" style="color: white; cursor:pointer" (click)='scrollTo(kontaktForm)'>Kontakt</a>
      </li>
      <li class="link2">
        <a class="link1" style="color: white; cursor:pointer" (click)='goToOffers()'>Robna Ponuda</a>
      </li>
      <!-- <li class="link2">
        <a class="link1" style="color: white; cursor:pointer" (click)='goToTransport()'>Transport</a>
      </li> -->
      <li class="link2">
        <a class="login-button" (click)='goToLogin()'>Uloguj se</a>
      </li>
    </ul>
  </div>
<ngb-carousel style="margin-bottom: 50px">
  <ng-template ngbSlide>
    <div class="picsum-img-wrapper">
      <img src="/assets/images/home_1.jpg" alt="Random first slide" class="carousel-image">
    </div>
    <div class="carousel-caption custom-caption">
      <div class="slider-content">
        <div class="slider-t1">Agro Informer d.o.o.</div>
        <h2 class="slider-t2 text-white">Vašem uspješnom poslovanju<br><span>pravu moć daje prava informacija!</span></h2>
        <p class="mt-5 mt-md-10">
          <span class="d-none d-sm-block"><a class="login-button" (click)='scrollTo(kontaktForm)'>Kontakt</a></span>
        </p>
      </div>
    </div>
  </ng-template>

  <ng-template ngbSlide>
    <div class="picsum-img-wrapper">
      <img src="/assets/images/home_2.jpg" alt="Random second slide" class="carousel-image">
    </div>
    <div class="carousel-caption custom-caption">
      <div class="slider-content">
        <div class="slider-t1">Agro Informer d.o.o.</div>
        <h2 class="slider-t2 text-white">Sa pravom informacijom je uvijek lakše donijeti pravu odluku..</h2>
        <p class="mt-5 mt-md-10">
          <span class="d-none d-sm-block"><a class="login-button" (click)='scrollTo(kontaktForm)'>Kontakt</a></span>
        </p>
      </div>
    </div>
  </ng-template>

  <!-- <ng-template ngbSlide>
    <div class="picsum-img-wrapper">
      <img src="/assets/images/home_3.jpg" alt="Random third slide" class="carousel-image">
    </div>
    <div class="carousel-caption custom-caption">
      <div class="slider-content">
        <div class="slider-t1">Agro Informer d.o.o.</div>
        <h2 class="slider-t2 text-black">Oglasite se, pronađite lako transport za Vaš teret, uštedite vrijeme i novac!</h2>
        <h2 class="slider-t2 text-black">Ponude utovara i slobodnih vozila, sve informacije na jednom mjestu!</h2>
        <p class="mt-5 mt-md-10">
          <span class="d-none d-sm-block"><a class="login-button" (click)='scrollTo(kontaktForm)'>Kontakt</a></span>
        </p>
      </div>
    </div>
  </ng-template> -->
</ngb-carousel>

  <div>
    <section class="section" style="padding-top: 140px;padding-bottom: 140px;">
      <div class="container" style="max-width: 1170px;">
        <div style="margin: 0 270px 60px 270px">
          <h2 class="agro-text-1">„Agro Informer“</h2>

          <p class="agro-text">"Agro Informer” d.o.o. sa sjedištem u Bijeljini se bavi prikupljanjem i prosljeđivanjem informacija vezanih za poljoprivredu i prehranu u širem regionu.</p>
        </div>

        <!-- start feature -->
        <div class="feature feature--style-1">
          <div class="__inner">
            <div class="row">
              <div class="col-6 col-sm-4 col-lg-3"></div>
              <!-- start item -->
              <!-- <div class="col-6 col-sm-4 col-lg-3">
                <div class="__item  text-center" style="cursor:pointer" (click)='goToTransport()'>
                  <i class="__ico">
                    <img class="img-fluid lazy loaded" src="/assets/images/truck.png" alt="demo" data-was-processed="true" style="height:66px;">
                  </i>

                  <h5 class="__title">Transport</h5>
                </div>
              </div> -->
              <!-- end item -->
              <!-- start item -->
              <div class="col-12 col-sm-8 col-lg-6">
                <div class="__item  text-center" style="cursor:pointer" (click)='goToOffers()'>
                  <i class="__ico">
                    <img class="img-fluid lazy loaded" src="/assets/images/5.png" alt="demo" data-was-processed="true">
                  </i>

                  <h5 class="__title">Poljoprivreda/Prehrana</h5>
                </div>
              </div>
              <!-- end item -->
            </div>
          </div>
        </div>
        <!-- end feature -->
      </div>
    </section>
    <section class="section">
      <div class="container" style="max-width: 1170px;">
        <h2 class="text-center background-text">Budite uvijek informisani o ponudi konkurenata i potražnji kupaca</h2>
      </div>
    </section>
    <section class="section">
      <div class="container agro-back">
        <div class="row align-items-center">
          <div class="col-12 col-lg-4">
            <div>
              <div class="something1">
                <h2 class="title">Potpune informacije <span>dostupne samo za korisnike</span></h2>
              </div>

              <p class="d-none d-sm-block">
                <a class="login-button2" (click)='goToLogin()'>Uloguj se</a>
              </p>
            </div>
          </div>

          <div class="col-12 my-3 d-lg-none"></div>

          <div class="col-12 col-lg-4  text-center">
            <div>
              <img class="img-fluid  lazy" src="/assets/images/grain.png" alt="demo" />
            </div>
          </div>

          <div class="col-12 my-3 d-lg-none"></div>

          <div class="col-12 col-lg-4">
            <div>
              <p class="agro-text-2 ">
                Za sve informacije o stanju i cijenama na tržištu korisnik se može informisati i telefonskim putem,
                pozivom u našu kancelariju.
              </p>

              <p class="agro-text-2 ">
                Ovakvim načinom informisanja ste uvijek u toku sa stanjem na tržištu,aktuelnim cijenama, trenutnim
                ponudama/potražnjama roba i realizovanim cijenama. “Agro Informer” Vam pruža uvijek tačnu informaciju, a
                svaka pravovremena i tačna informacija Vama omogućava da lakše pronadjete kupce i obezbjedite najbolje
                dobavljače
              </p>

              <p class="d-sm-none">
                <a class="custom-btn login-button" href="#">More about</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section">
      <div class="container yellow-background">
        <div class="col-12 col-sm-8 col-md-6 col-lg-5 col-xl-2"></div>
        <div class="col-12 col-sm-8 col-md-6 col-lg-5 col-xl-3">
          <div class="__item">
            <div class="d-table">
              <div class="d-table-cell align-middle">
                <i class="__ico">
                  <img class="img-fluid  lazy" src="/assets/images/ico/ico_count_1.png" alt="demo" />
                </i>
              </div>

              <div class="d-table-cell align-middle">
                <p class="__count js-count yellow-background-number" data-from="0" data-to="19500">{{numbers[0]}}</p>

                <p class="__title yellow-background-text">Ponuda na današnji dan</p>
              </div>
            </div>
          </div>
        </div>
        <!-- end item -->

        <!-- start item -->
        <div class="col-12 col-sm-8 col-md-6 col-lg-5 col-xl-2">
          <div class="__item">
            <div class="d-table">
              <div class="d-table-cell align-middle">
                <i class="__ico">
                  <img class="img-fluid  lazy" src="/assets/images/ico/ico_count_3.png" alt="demo" />
                </i>
              </div>

              <div class="d-table-cell align-middle">
                <p class="__count js-count yellow-background-number" data-from="0" data-to="10000">{{numbers[1]}}</p>

                <p class="__title yellow-background-text">Potražnji na današnji dan</p>
              </div>
            </div>
          </div>
        </div>
        <!-- end item -->

        <!-- start item -->
        <!-- <div class="col-12 col-sm-8 col-md-6 col-lg-5 col-xl-3">
          <div class="__item">
            <div class="d-table">
              <div class="d-table-cell align-middle">
                <i class="__ico">
                  <img class="img-fluid  lazy" src="/assets/images/ico/ico_count_4.png" alt="demo" />
                </i>
              </div>

              <div class="d-table-cell align-middle">
                <p class="__count js-count yellow-background-number" data-from="0" data-to="128">{{numbers[2]}}</p>

                <p class="__title yellow-background-text">Ponuda transporta na današnji dan</p>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </section>
    <section class="section section-about">
      <div class="container" style="max-width: 1200px">
        <div class="section-heading">
          <h2 class="title-about">O nama</h2>
        </div>

        <div class="row">
          <div class="col-12 col-lg-6 col-xl-8">
            <p class="text-about">
              Agro Informer" d.o.o. sa sjedištem u Bijeljini bavi se prikupljanjem informacija vezanih za poljoprivredu
              i prehranu na tržištu Ex Jugoslavije, Madjarske, Italije, Austrije, Albanije, Bugarske...
            </p>
            <!-- <p class="text-about">
              Uz informacije o ponudi i potražnji roba, takođe nudimo informacije iz oblasti unutrašnjeg i međunarodnog
              transporta, tj. informacije o ponudi utovara i slobodnih vozila u širem regionu.
            </p> -->
            <p class="text-about">
              Iz sjedišta u Bijeljini obavljamo direktne telefonske kontakte sa firmama u okruženju, te prikupljene
              informacije šaljemo korisnicima u sistemu i ostalim načinima komunikacije (Sms, Viber, WhatsApp, E-mail).
            </p>
            <p class="text-about">
              Korisnici usluga “Agro Informera” preko našeg sistema svakodnevno objavljuju ponude i potražnje
              roba/usluga,
              te redovno primaju informacije o ponudi/potražnji od strane ostalih korisnika sistema sa navedenih
              tržišta.
            </p>
            <p class="text-about">
              Za sve korisnike sistema dostupni su robni izvještaji na dnevnom/sedmičnom nivou, dnevni pregled promjena
              cijena na svjetskim berzama, kretanja cijena u regionu na dnevnom/sedmičnom nivou ili sve to možete da
              pratite na našoj Web stranici uz neograničen broj pristupa.
            </p>
            <p class="text-about">
              Sve prikupljene informacije za Vaše tržište su naravno u Vašoj valuti, dok informacije sa drugih tržišta
              možete pratiti posebno po tržištu ili u Euro valuti na dijelu sajta namijenjenom za izvoz/uvoz roba.
            </p>
            <p class="text-about">
              Za sve informacije o stanju i cijenama na tržištu korisnik se može informisati i telefonskim putem,
              pozivom
              u našu kancelariju.
            </p>
            <p class="text-about">
              Ovakvim načinom informisanja ste uvijek u toku sa stanjem na tržištu, aktuelnim cijenama, trenutnim
              ponudama/potražnjama roba/utovara i realizovanim cijenama.
            </p>
            <p class="text-about">
              “Agro Informer” Vam pruža uvijek tačnu informaciju, a svaka pravovremena i tačna informacija Vam omogućava
              da lakše pronadjete kupce i obezbijedite najbolje dobavljače.
            </p>
            <p class="text-about">
              Budite uvijek informisani o ponudi konkurenata i potražnji kupaca, jer sa pravom informacijom je uvijek
              lakše donijeti pravu odluku!
            </p>
            <p class="d-none d-sm-block" style="margin-top: 15px">
              <a class="login-button2" (click)='goToLogin()'>Uloguj se</a>
            </p>
          </div>
        </div>
      </div>
    </section>
    <section class="section section--review  lazy review-bg">
      <div class="container" style="max-width: 1200px">
        <div class="section-heading">
          <h2 class="title-about">Šta drugi <span style="font-weight: 100">kažu o nama</span></h2>

          <p>Komentare naših zadovoljnih klijenata možete pogledati ispod</p>
        </div>
        <!-- start review -->
<!-- <swiper [config]="config2">
  <ng-container *ngFor="let comment of comments">
    <swiper-slide>
      <div class="review__item">
        <div class="review__item__text">
          <p>
            <i>{{comment.text}}</i>
          </p>
        </div>
        <div class="review__item__author d-table">
          <div class="d-table-cell align-middle">
            <span class="review__item__author-name">
              <strong>{{comment.person}}</strong>
            </span>
            <span class="review__item__author-position">/{{comment.from}}</span>
          </div>
        </div>
      </div>
    </swiper-slide>
  </ng-container>
</swiper> -->
        <!-- start review -->
      </div>
    </section>
    <section class="section section--review  lazy" data-src="img/review_bg_1.png"
      style="margin-top: 100px; margin-bottom: 50px;">
      <div class="container" style="max-width: 1550px">
        <!-- <swiper [config]="config">
          <div *ngFor="let image of images" style="text-align: center;">
            <img src="{{image}}" alt="Random first slide" style="max-width: 260px; max-height: 150px;">
          </div>
        </swiper> -->
      </div>
    </section>
    <section class="section section--review  lazy" #kontaktForm data-src="img/review_bg_1.png"
      style="padding-top:140px;padding-bottom:140px;background-color: #333;">
      <div class="container">
        <div class="section-heading section-heading--center section-heading--white" data-aos="fade">
          <h2 class="__title contack-title">Kontaktirajte <span>nas</span></h2>


        </div>

        <form class="contact-form js-contact-form" action="#">
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="input-wrp">
                <input class="textfield no-border-radius" name="name" type="text" placeholder="Ime firme"
                  [(ngModel)]="contact.imeFirme" />
              </div>
            </div>

            <div class="col-12 col-md-6">
              <div class="input-wrp">
                <input class="textfield no-border-radius" name="email" type="text" placeholder="E-mail adresa"
                  [(ngModel)]="contact.email" />
              </div>
            </div>
          </div>

          <div class="input-wrp">
            <textarea class="textfield no-border-radius" name="message" placeholder="Poruka"
              [(ngModel)]="contact.poruka"></textarea>
          </div>

          <button class="custom-btn custom-btn--medium custom-btn--style-3 wide login-button2" style="width: inherit;"
            type="button" role="button" (click)="sendContact()">Pošalji</button>

          <div *ngIf="sent" class="col-sm-12 confirm-message">Poruka je poslana</div>

          <div class="form__note"></div>
        </form>
      </div>
    </section>
    <section class="section" style="padding-top: 40px;padding-bottom: 140px;">
      <div class="container" style="max-width: 1170px;">
        <div class="row">
          <div class="col-12 col-sm-auto">
            <div class="footer__item">
              <a class="site-logo" href="index.html">
                <img class="img-fluid  lazy" src="/assets/images/800x800_logo.png" width="140px" alt="demo" />
              </a>
            </div>
          </div>

          <div class="col-12 col-sm">
            <div class="row no-gutters">
              <div class="col-12 col-md">
                <div class="footer__item">
                  <h5 class="h6 font-kontakt-header">Adresa</h5>
                  <address>
                    <p class="font-kontakt-text">
                      Agro Informer d.o.o.<br>
                      Ive Andrića bb, lokal br. 4<br>
                      (u sklopu "Tržnice Intergaj") <br>
                      76300 Bijeljina <br>
                      Bosna i Hercegovina
                    </p>
                  </address>
                </div>
              </div>

              <div class="col-12 col-md-auto">
                <div class="footer__item">
                  <h5 class="h6 font-kontakt-header">Kontakt telefoni</h5>
                  <p class="font-kontakt-text">
                    Tel (BiH): +387 55 423 873 <br>
                    Tel/Fax (BiH): +38755 423 863 <br>
                    Centrala (SI): +386 1 8888 966 <br>
                    Mob (BiH): +387 66 785-431 (Viber) <br>
                    Mob (BiH): +387 66 908 194 (Viber)<br>
                    Mob (BiH): +387 65 529 979 (Viber)<br>
                    Mob (BiH): +387 66 186 126 (Viber)<br>
                    Mob (AT): +43 66 77 88 3492 <br>
                    Mob (AT): +43 66 77 88 3495 <br>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-lg-5 col-xl-4 offset-xl-1">
            <div class="footer__item">
              <h5 class="h6 font-kontakt-header">E-mail adrese</h5>
              <p class="font-kontakt-text">
                office@agroinformer.co<br>
                agroinformerbn@gmail.com
              </p>
              <h5 class="h6 font-kontakt-header">Skype</h5>
              <p class="font-kontakt-text">
                agroinformer.co
              </p>
              <h5 class="h6 font-kontakt-header"><a
                  href="https://www.facebook.com/pages/Agro-Informer-doo-Bijeljina/228394874016444?ref=hl">Facebook</a>
              </h5>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
